import { render, staticRenderFns } from "./PoliticaDePrivacidade.vue?vue&type=template&id=01c5f00c&"
import script from "./PoliticaDePrivacidade.vue?vue&type=script&lang=js&"
export * from "./PoliticaDePrivacidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports